export const getApiPath = () => {
	return window.location.hostname === 'localhost' ? 'http://localhost:3001/' : 'https://stream.skarb.com/';
};
